import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Check, Newspaper } from "lucide-react";
import { api } from "../lib/api";

const TOPICS = ["Restaurantes", "Eventos", "Ofertas", "Negocios nuevos", "Lugares para visitar"];

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [topics, setTopics] = useState([]);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [issues, setIssues] = useState([]);

  useEffect(() => { api.issues().then(setIssues).catch(() => {}); }, []);

  const toggle = (t) => setTopics((p) => (p.includes(t) ? p.filter((x) => x !== t) : [...p, t]));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.subscribe({ email, topics });
      toast.success(res.message || "¡Suscrito!");
      setDone(true);
    } catch { toast.error("No se pudo suscribir."); } finally { setBusy(false); }
  };

  return (
    <div className="mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-8">
      <div className="grid gap-8 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-brand/10 px-3 py-1 text-xs font-bold uppercase tracking-wider text-brand">
            <Newspaper className="h-3.5 w-3.5" /> Cada 2–3 días
          </span>
          <h1 className="mt-3 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">Newsletter en español</h1>
          <p className="mt-2 text-muted-foreground">Negocios destacados, ofertas, eventos y lugares para visitar. Contenido curado y verificado, sin spam.</p>

          {done ? (
            <div data-testid="subscribe-success" className="mt-6 flex items-center gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 p-5">
              <Check className="h-6 w-6 text-emerald-600" />
              <p className="font-semibold text-emerald-800">¡Listo! Pronto recibirás nuestro newsletter.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div className="relative">
                <Mail className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-muted-foreground" />
                <input data-testid="newsletter-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.com" className="h-14 w-full rounded-full border border-input bg-white pl-12 pr-4 text-base outline-none focus:ring-2 focus:ring-brand/40" />
              </div>
              <div className="flex flex-wrap gap-2">
                {TOPICS.map((t) => (
                  <button type="button" key={t} data-testid={`topic-${t}`} onClick={() => toggle(t)} className={`rounded-full border px-3 py-1.5 text-sm font-medium transition-colors ${topics.includes(t) ? "border-brand bg-brand text-white" : "border-border bg-white hover:border-brand/40"}`}>
                    {t}
                  </button>
                ))}
              </div>
              <button data-testid="newsletter-subscribe-btn" disabled={busy} className="h-14 w-full rounded-full bg-brand text-base font-bold text-white hover:bg-brand-hover disabled:opacity-60">
                {busy ? "Suscribiendo..." : "Suscribirme gratis"}
              </button>
            </form>
          )}
        </div>

        <div className="rounded-3xl border border-border bg-card p-6">
          <h2 className="font-display text-lg font-bold">Ediciones recientes</h2>
          {issues.length === 0 ? (
            <p className="mt-3 text-sm text-muted-foreground">Aún no hay ediciones publicadas. ¡Suscríbete para no perderte la primera!</p>
          ) : (
            <div className="mt-4 space-y-3">
              {issues.map((it) => (
                <div key={it.id} data-testid={`issue-${it.id}`} className="rounded-2xl bg-secondary/60 p-4">
                  <p className="font-semibold text-brand-ink">{it.subject}</p>
                  <p className="mt-1 line-clamp-2 text-sm text-muted-foreground">{it.preview_text || (it.blocks?.[0]?.body)}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
